'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassDetailCard = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassDetailCard = exports.ClassDetailCard = function (_PureComponent) {
  (0, _inherits3.default)(ClassDetailCard, _PureComponent);

  function ClassDetailCard() {
    (0, _classCallCheck3.default)(this, ClassDetailCard);
    return (0, _possibleConstructorReturn3.default)(this, (ClassDetailCard.__proto__ || (0, _getPrototypeOf2.default)(ClassDetailCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(ClassDetailCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          endTime = _props.endTime,
          extraClass = _props.extraClass,
          klassName = _props.klassName,
          startTime = _props.startTime,
          venueName = _props.venueName;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('class-detail-card', extraClass) },
        _react2.default.createElement(
          'span',
          { className: 'class-detail-card__class' },
          klassName
        ),
        _react2.default.createElement(
          'span',
          null,
          venueName
        ),
        _react2.default.createElement(_reactIntl.FormattedDate, {
          id: 'class-detail-card.date',
          value: startTime * 1e3,
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        }),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'class-detail-card.time',
          defaultMessage: '{startTime} - {endTime}',
          values: {
            startTime: _react2.default.createElement(_reactIntl.FormattedTime, {
              value: startTime * 1e3,
              hour: 'numeric',
              minute: 'numeric'
            }),
            endTime: _react2.default.createElement(_reactIntl.FormattedTime, {
              value: endTime * 1000,
              hour: 'numeric',
              minute: 'numeric'
            })
          }
        }),
        children
      );
    }
  }]);
  return ClassDetailCard;
}(_react.PureComponent);

ClassDetailCard.propTypes = {
  children: _propTypes2.default.node,
  endTime: _propTypes2.default.number.isRequired,
  extraClass: _propTypes2.default.string,
  klassName: _propTypes2.default.string.isRequired,
  startTime: _propTypes2.default.number.isRequired,
  venueName: _propTypes2.default.string.isRequired
};